module.exports = __webpack_public_path__ + "img/vessel_visitation_11_63021.f794cf92.jpg";